import React, { useEffect, useState } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import { authAPI } from '../utils/api';
import useAuthStore from '../store/authStore';

const VerifyEmail = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [status, setStatus] = useState('loading');
  const [message, setMessage] = useState('');
  const [email, setEmail] = useState('');
  const [resending, setResending] = useState(false);
  const [resent, setResent] = useState(false);

  useEffect(() => {
    const token = searchParams.get('token');
    if (!token) { setStatus('error'); setMessage('Geçersiz bağlantı.'); return; }

    authAPI.verifyEmail(token)
      .then(({ data }) => {
        localStorage.setItem('token', data.token);
        localStorage.setItem('refreshToken', data.refreshToken);
        useAuthStore.setState({ user: data.user, token: data.token, refreshToken: data.refreshToken, initialized: true });
        setStatus('success');
        setTimeout(() => {
          const role = data.user.role;
          navigate(role === 'student' ? '/student' : role === 'company' ? '/company' : '/admin');
        }, 2500);
      })
      .catch(err => {
        setStatus('error');
        setMessage(err.response?.data?.error || 'Doğrulama başarısız. Bağlantı süresi dolmuş olabilir.');
      });
  }, []);

  const handleResend = async () => {
    if (!email) return;
    setResending(true);
    try {
      await authAPI.resendVerification(email);
      setResent(true);
    } catch {}
    setResending(false);
  };

  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center p-4">
      <div className="w-full max-w-md bg-white rounded-2xl p-10 shadow-sm text-center">
        {status === 'loading' && (
          <>
            <div className="text-5xl mb-4">⏳</div>
            <h2 className="text-xl font-bold text-gray-900 mb-2">Doğrulanıyor...</h2>
            <p className="text-gray-500 text-sm">Lütfen bekleyin.</p>
          </>
        )}
        {status === 'success' && (
          <>
            <div className="text-5xl mb-4">✅</div>
            <h2 className="text-xl font-bold text-green-700 mb-2">E-posta Doğrulandı!</h2>
            <p className="text-gray-500 text-sm">Hesabınız aktif. Panele yönlendiriliyorsunuz...</p>
          </>
        )}
        {status === 'error' && (
          <>
            <div className="text-5xl mb-4">❌</div>
            <h2 className="text-xl font-bold text-red-600 mb-2">Doğrulama Başarısız</h2>
            <p className="text-gray-500 text-sm mb-6">{message}</p>

            {resent ? (
              <p className="text-green-600 text-sm mb-4">Doğrulama maili tekrar gönderildi. Gelen kutunuzu kontrol edin.</p>
            ) : (
              <div className="mb-5">
                <p className="text-sm text-gray-600 mb-3">Yeni doğrulama maili almak için e-posta adresinizi girin:</p>
                <input
                  type="email"
                  placeholder="ornek@email.com"
                  value={email}
                  onChange={e => setEmail(e.target.value)}
                  className="w-full px-3.5 py-2.5 border border-gray-300 rounded-lg text-sm outline-none focus:border-blue-500 focus:ring-1 focus:ring-blue-500 mb-3"
                />
                <button
                  onClick={handleResend}
                  disabled={resending || !email}
                  className="w-full py-2.5 bg-blue-600 hover:bg-blue-700 disabled:bg-blue-300 text-white rounded-lg text-sm font-medium transition-colors"
                >
                  {resending ? 'Gönderiliyor...' : 'Yeni Mail Gönder'}
                </button>
              </div>
            )}

            <a href="/login" className="text-sm text-blue-600 hover:underline">
              Giriş sayfasına dön
            </a>
          </>
        )}
      </div>
    </div>
  );
};

export default VerifyEmail;
